// extracted by mini-css-extract-plugin
export var container = "resume-module--container--F0jCq";
export var content = "resume-module--content--Fzth6";
export var label = "resume-module--label--VgD8e";
export var line = "resume-module--line--IBQ5P";
export var resume = "resume-module--resume--85isD";
export var tools = "resume-module--tools--3de4v";